import { Checkbox, Radio, message } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import { Popover, Button, Modal } from "antd";
import {
  CaretDownOutlined,
  CaretRightOutlined,
  SortAscendingOutlined,
  SortDescendingOutlined,
} from "@ant-design/icons";
import {
  useTable,
  useGlobalFilter,
  useFilters,
  useSortBy,
  usePagination,
  useBlockLayout,
  useResizeColumns,
  useRowSelect,
  useExpanded,
  useColumnOrder,
} from "react-table";
import { useSticky } from "react-table-sticky";
// import HowToRegIcon from "@mui/icons-material/HowToReg";
import { Styles } from "./styles";
import "./style.css";
import "../../common/common.css";

import PopoverMenu from "./PopoverMenu";
import PopoverMenuSolved from "./PopoverMenuSolved";

import ChangeSignatory from "../PartnerManagement/PartnerMenu/ChangeSignatory";
import ChangeThreshold from "../PartnerManagement/PartnerMenu/ChangeThreshold";
import ChangeRM from "../PartnerManagement/PartnerMenu/ChangeRM";
import ResendRegistrationLink from "../PartnerManagement/PartnerMenu/ResendRegistrationLink";
import ViewUserEditDetails from "../AccessManagement/UserMenu/ViewUserEditDetails";
import DeactivateUser from "../AccessManagement/UserMenu/DeactivateUser";
import ResendWelcomeMail from "../AccessManagement/UserMenu/ResendelcomeMail";
import ActivateUser from "../AccessManagement/UserMenu/ActivateUser";
import DeactivatePartner from "../PartnerManagement/PartnerMenu/DeactivatePartner";
import ActivatePartner from "../PartnerManagement/PartnerMenu/ApprovedPartner";
import EditLead from "../leadMangement/EditLead/EditLead";
import PartnerViewEditUserDetails from "../AddUserDetails/PartnerViewEditUserDetails";
import MakePrimaryUser from "../AddUserDetails/MakePrimaryUser";
import ActivatePartnerUser from "../AddUserDetails/ActivatePartnerUser";
import DeactivatePartnerUser from "../AddUserDetails/DeactivatePartnerUser";
import ResendPartnerWelcomeMail from "../AddUserDetails/ResendPartnerWelcomeMail";
import RemovePrimaryUser from "../AddUserDetails/RemovePrimaryUser";

const Table = (props) => {
  let history = useNavigate();
  const {
    COLUMNS,
    statusType,
    DATA,
    setSelectedRows,
    type,
    multiple,
    selectable,
    drawerTable,
    hiddenColumns = [],
    columnOrder = [],
    handleToggleSort,
    onRowClick,
    assignToMeClick,
    showExpanded,
    actionsColumn,
    permissionActionsColumn,
    actionDataList,
    pageTotalCount,
    pageIndexService,
    pageSizeService,
    paginationService,
    setPagination,
    setPartnerRefresh,
    partnerRefresh,
    callBackAPI,
    selectedTab,
  } = props;

  const columns = useMemo(() => COLUMNS, [COLUMNS]);
  const [wwidth, setWwidth] = useState(window.innerWidth - 150);

  const [thresholdDrawer, setThresholdDrawer] = useState(false);
  const [changeSignatoryDrawer, setChangeSignatoryDrawer] = useState(false);
  const [changeRMDrawer, setChangeRMDrawer] = useState(false);
  const [resendRegistrationLinkDrawer, setResendRegistrationLinkDrawer] =
    useState(false);

  const [deactivateUserDrawer, setDeactivateUserDrawer] = useState(false);
  const [editLeadDrawer, setEditLeadDrawer] = useState(false);
  const [activateUserDrawer, setActivateUserDrawer] = useState(false);
  const [resendWelcomeMailDrawer, setResendWelcomeMailDrawer] = useState(false);
  const [viewUserEditDetailsDrawer, setViewUserEditDetailsDrawer] =
    useState(false);
  const [makePrimaryDrawer, setMakePrimaryDrawer] = useState(false);
  const [removePrimaryDrawer, setRemovePrimaryDrawer] = useState(false);
  const [
    viewPartnerEditUserDetailsDrawer,
    setPartnerViewEditUserDetailsDrawer,
  ] = useState(false);

  const [activatePartnerUserDrawer, setActivatePartnerUserDrawer] =
    useState(false);
  const [deactivatePartnerUserDrawer, setDeactivatePartnerUserDrawer] =
    useState(false);
  const [resendPartnerWelcomeMailDrawer, setResendPartnerWelcomeMailDrawer] =
    useState(false);

  const [deactivatePartnerDrawer, setDeactivatePartnerDrawer] = useState(false);
  const [activatePartnerDrawer, setActivatePartnerDrawer] = useState(false);

  const [rowValue, setRowValue] = useState("");

  const { userData } = props.state.auth;

  const loggedInRoleType = userData?.loggedInRoleType;

  const redirectRoute =
    loggedInRoleType === "CET"
      ? "CETDashboard"
      : loggedInRoleType === "RM"
      ? "RMDashboard"
      : "";

  const data = useMemo(() => DATA, [DATA]);
  const actionDataListData = useMemo(() => actionDataList, [actionDataList]);
  const defaultColumn = React.useMemo(
    () => ({
      minWidth: 20,
      maxWidth: 200,
    }),
    []
  );

  const tableInstance = useTable(
    {
      columns,
      data,
      initialState: {
        hiddenColumns: selectable ? "" : ["selection"],
        pageIndex: pageIndexService,
        pageSize: pageSizeService,
      },
      defaultColumn,
      useControlledState: (state) => {
        return React.useMemo(
          () => ({
            ...state,
            hiddenColumns,
            columnOrder,
          }),
          [state, hiddenColumns, columnOrder]
        );
      },
      manualFilters: true,
      manualSortBy: true,
      manualPagination: true,
      pageCount: Math.ceil(pageTotalCount / pageSizeService) ?? -1,
    },

    useBlockLayout,
    useFilters,
    useGlobalFilter,
    useSortBy,
    useExpanded,
    useResizeColumns,
    usePagination,
    useRowSelect,
    useColumnOrder,
    useSticky,
    (hooks) => {
      hooks.visibleColumns.push((columns) => [
        // Let's make a column for selection
        {
          id: "selection",
          // The header can use the table's getToggleAllRowsSelectedProps method
          // to render a checkbox
          Header: ({ getToggleAllRowsSelectedProps }) => (
            <div>
              {selectable &&
                (multiple ? (
                  <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
                ) : (
                  ""
                ))}
            </div>
          ),
          sticky: "left",
          width: 50,
          minWidth: 50,
          maxWidth: 300,
          // The cell can use the individual row's getToggleRowSelectedProps method
          // to the render a checkbox
          Cell: ({
            row,
            toggleAllRowsSelected,
            toggleRowSelected,
            getToggleAllRowsExpandedProps,
          }) => (
            <div>
              {actionsColumn && (
                // <PopoverMenu
                //   row={row}
                //   actionDataList={actionDataListData}
                //   setPartnerRefresh={setPartnerRefresh}
                //   partnerRefresh={partnerRefresh}
                //   callBackAPI={callBackAPI}
                // />
                <PopoverMenuSolved
                  row={row}
                  actionDataList={actionDataList}
                  setRowValue={setRowValue}
                  setThresholdDrawer={setThresholdDrawer}
                  setChangeSignatoryDrawer={setChangeSignatoryDrawer}
                  setChangeRMDrawer={setChangeRMDrawer}
                  setResendRegistrationLinkDrawer={
                    setResendRegistrationLinkDrawer
                  }
                  setDeactivateUserDrawer={setDeactivateUserDrawer}
                  setResendWelcomeMailDrawer={setResendWelcomeMailDrawer}
                  setActivateUserDrawer={setActivateUserDrawer}
                  // setModifyBankDetailsDrawer={setModifyBankDetailsDrawer}
                  setActivatePartnerDrawer={setActivatePartnerDrawer}
                  setDeactivatePartnerDrawer={setDeactivatePartnerDrawer}
                  setViewUserEditDetailsDrawer={setViewUserEditDetailsDrawer}
                  setPartnerViewEditUserDetailsDrawer={
                    setPartnerViewEditUserDetailsDrawer
                  }
                  setActivatePartnerUserDrawer={setActivatePartnerUserDrawer}
                  setDeactivatePartnerUserDrawer={
                    setDeactivatePartnerUserDrawer
                  }
                  setResendPartnerWelcomeMailDrawer={
                    setResendPartnerWelcomeMailDrawer
                  }
                  setMakePrimaryDrawer={setMakePrimaryDrawer}
                  setRemovePrimaryDrawer={setRemovePrimaryDrawer}
                  history={history}
                  redirectRoute={redirectRoute}
                />
              )}

              {showExpanded && row.getToggleRowExpandedProps ? (
                <span
                  {...row.getToggleRowExpandedProps({
                    style: {
                      // We can even use the row.depth property
                      // and paddingLeft to indicate the depth
                      // of the row
                      paddingLeft: `${row.depth * 2}rem`,
                    },
                  })}
                >
                  {row.isExpanded ? (
                    <CaretDownOutlined />
                  ) : (
                    <CaretRightOutlined />
                  )}
                </span>
              ) : null}

              {selectable &&
                (multiple ? (
                  <IndeterminateCheckbox
                    className="text-center"
                    {...row.getToggleRowSelectedProps()}
                  />
                ) : (
                  <IndeterminateCheckbox
                    className="text-center"
                    {...row.getToggleRowSelectedProps()}
                    onClick={() => {
                      toggleAllRowsSelected(false);
                      toggleRowSelected(row.id, true);
                    }}
                  />
                ))}
            </div>
          ),
          disableSortBy: true,
        },

        // {
        //   id: "age",
        //   // The header can use the table's getToggleAllRowsSelectedProps method
        //   // to render a checkbox
        //   Header: "Age",
        //   sticky: "left",
        //   width: 50,
        //   minWidth: 50,
        //   maxWidth: 150,
        //   canSort: true,
        //   // The cell can use the individual row's getToggle  RowSelectedProps method
        //   // to the render a checkbox
        //   Cell: ({ row }) => <div className="ageBar">1h</div>,
        //   // disableSortBy: true
        // },
        ...columns,
      ]);
    }
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    state,
    prepareRow,
    selectedFlatRows,
    setGlobalFilter,
  } = tableInstance; // i have changed the spelling of this... it was tabelInstnce

  const {
    globalFilter,
    selectedRowIds,
    sortBy,
    pageIndex,
    pageSize,
    // pagination = paginationService,
  } = state;

  // change state pageIndex to props pageIndex
  useEffect(() => {
    setPagination({
      pageIndex: pageIndex,
      pageSize: pageSize,
    });
  }, [pageIndex, pageSize]);

  useEffect(() => {
    if (selectedTab) {
      gotoPage(0);
      // setPageSize(10);
      setPageSize(pageSizeService);
    }
  }, [selectedTab]);

  //Hiding All Columns Except first Child of Every Header On Page Load ---Starts Here
  useEffect(() => {
    tableInstance.columns.map((column) => {
      if (column.columns) {
        column.columns.slice(1).map((childColumn) => {
          childColumn.toggleHidden(true);
        });
      }
    });
  }, [tableInstance.columns]);
  //------Ends Here
  const handleResize = () => {
    setWwidth(window.innerWidth - 150);
  };
  useEffect(() => {
    window.addEventListener("resize", handleResize, false);
  }, []);
  useEffect(() => {
    if (selectable && selectedFlatRows.length > 0) {
      if (!multiple) {
        setSelectedRows({
          selectedRowValue: selectedFlatRows[0]?.original,
          selectedRowId: selectedFlatRows[0]?.id,
        });
      } else {
        setSelectedRows(selectedFlatRows);
      }
    }
  }, [selectable, selectedFlatRows, setSelectedRows]);
  const IndeterminateCheckbox = React.forwardRef(
    ({ indeterminate, ...rest }, ref) => {
      const defaultRef = React.useRef();
      const resolvedRef = ref || defaultRef;

      React.useEffect(() => {
        resolvedRef.current.indeterminate = indeterminate;
      }, [resolvedRef, indeterminate]);

      return (
        <>
          {multiple ? (
            <Checkbox ref={resolvedRef} {...rest} />
          ) : (
            <Radio ref={resolvedRef} {...rest} />
          )}
        </>
      );
    }
  );

  return (
    <Styles>
      {/* <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} /> */}
      <div
        className={
          type === "sec-table"
            ? "section-table"
            : type === "draw-table"
            ? " drawer-table"
            : ""
        }
      >
        <div
          {...getTableProps()}
          className="table sticky"
          style={{ width: "100%", height: "408px" }}
        >
          <div className="header">
            {headerGroups.map((headerGroup) => (
              <div {...headerGroup.getHeaderGroupProps()} className="tr">
                {headerGroup.headers.map((column) => (
                  <div {...column.getHeaderProps()} className="th">
                    <div className="column-header">
                      <span>{column.render("Header")}</span>

                      {column.id !== "age" && column.canSort && (
                        <span
                          {...column.getSortByToggleProps()}
                          style={{ cursor: "pointer" }}
                        >
                          {column.isSortedDesc ? (
                            <SortDescendingOutlined
                              onClick={() => handleToggleSort(column, "desc")}
                            />
                          ) : !column.isSortedDesc ? (
                            <SortAscendingOutlined
                              onClick={() => handleToggleSort(column, "asc")}
                            />
                          ) : (
                            <SortAscendingOutlined
                              onClick={() => handleToggleSort(column, "asc")}
                            />
                          )}
                        </span>
                      )}
                    </div>

                    {column.canResize && (
                      <div {...column.getResizerProps()} className="resizer" />
                    )}
                  </div>
                ))}
              </div>
            ))}
            {headerGroups.map((headerGroup) => (
              <div {...headerGroup.getHeaderGroupProps()} className="tr">
                {headerGroup.headers.map((column) => (
                  <div {...column.getHeaderProps()} className="th">
                    <div className="cell-size">
                      {column.id !== "age" && column.canFilter
                        ? column.render("Filter")
                        : null}
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>
          <div
            {...getTableBodyProps()}
            className="body"
            style={{ width: "100%" }}
          >
            {(page.length > 0 &&
              page.map((row) => {
                prepareRow(row);
                return (
                  <div {...row.getRowProps()} className="tr">
                    {row.cells.map((cell, i) => (
                      <div
                        {...cell.getCellProps()}
                        // onClick={() => {
                        //   if (
                        //     onRowClick &&
                        //     typeof onRowClick === "function" &&
                        //     i != 0
                        //   ) {
                        //     onRowClick(row);
                        //   } else return null;
                        // }}
                        className="td break-words"
                      >
                        {cell.render("Cell")}
                      </div>

                      // <div {...cell.getCellProps()} onClick={handleRedirect} className="td">
                      //   {cell.render("Cell")}
                      // </div>
                    ))}
                  </div>
                );
              })) || <span className="nodatatxt">No Data</span>}
          </div>
        </div>
        <div className="footer">
          <span className="page-label">
            Page{" "}
            <strong>
              {pageIndexService + 1} of {pageOptions.length}
            </strong>{" "}
          </span>
          <span className="page-select">
            Go to page{" "}
            <input
              type="number"
              defaultValue={pageIndexService + 1}
              onChange={(e) => {
                const pageNumber = e.target.value
                  ? Number(e.target.value) - 1
                  : 0;

                gotoPage(pageNumber);
              }}
              style={{
                width: 50,
              }}
            />
          </span>
          {/* <span>
            <select
              value={pageSizeService}
              onChange={(e) => setPageSize(Number(e.target.value))}
              className="show-page"
            >
              {[5, 10, 20, 25].map((pageSize) => (
                <option key={pageSize} value={pageSize}>
                  Show {pageSize}
                </option>
              ))}
            </select>{" "}
            <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
              {"<<"}
            </button>{" "}
            <button onClick={() => previousPage()} disabled={!canPreviousPage}>
              Prev
            </button>{" "}
            <button onClick={() => nextPage()} disabled={!canNextPage}>
              Next
            </button>{" "}
            <button
              onClick={() => gotoPage(pageCount - 1)}
              disabled={!canNextPage}
            >
              {">>"}
            </button>
          </span> */}
          <span>
            <select
              value={pageSize}
              onChange={(e) => setPageSize(Number(e.target.value))}
              className="show-page"
            >
              {[5, 10, 20, 25].map((pageSize) => (
                <option key={pageSize} value={pageSize}>
                  Show {pageSize}
                </option>
              ))}
            </select>{" "}
            <button
              className="pagination-btn"
              onClick={() => gotoPage(0)}
              disabled={!canPreviousPage}
            >
              {"<<"}
            </button>{" "}
            <button
              className="pagination-btn"
              onClick={() => previousPage()}
              disabled={!canPreviousPage}
            >
              Prev
            </button>{" "}
            {pageOptions.map((item) => (
              <button
                className={`pagination-btn ${
                  pageIndex === item ? "active" : ""
                }`}
                onClick={() => gotoPage(item)}
              >
                {item + 1}
              </button>
            ))}
            <button
              className="pagination-btn"
              onClick={() => nextPage()}
              disabled={!canNextPage}
            >
              Next
            </button>{" "}
            <button
              className="pagination-btn"
              onClick={() => gotoPage(pageCount - 1)}
              disabled={!canNextPage}
            >
              {">>"}
            </button>
          </span>
        </div>
      </div>

      {/* <ModifyBankDetails
        drawerOpen={modifyBankDetailsDrawer}
        setDrawerOpen={setModifyBankDetailsDrawer}
        row={rowValue}
      /> */}
      <ChangeThreshold
        drawerOpen={thresholdDrawer}
        setDrawerOpen={setThresholdDrawer}
        setPartnerRefresh={setPartnerRefresh}
        partnerRefresh={partnerRefresh}
        row={rowValue}
      />

      <ChangeSignatory
        drawerOpen={changeSignatoryDrawer}
        setDrawerOpen={setChangeSignatoryDrawer}
        setPartnerRefresh={setPartnerRefresh}
        partnerRefresh={partnerRefresh}
        row={rowValue}
      />

      <ChangeRM
        drawerOpen={changeRMDrawer}
        setDrawerOpen={setChangeRMDrawer}
        setPartnerRefresh={setPartnerRefresh}
        partnerRefresh={partnerRefresh}
        row={rowValue}
      />

      <ResendRegistrationLink
        drawerOpen={resendRegistrationLinkDrawer}
        setDrawerOpen={setResendRegistrationLinkDrawer}
        row={rowValue}
      />

      <ViewUserEditDetails
        drawerOpen={viewUserEditDetailsDrawer}
        setDrawerOpen={setViewUserEditDetailsDrawer}
        setPartnerRefresh={setPartnerRefresh}
        partnerRefresh={partnerRefresh}
        row={rowValue}
      />

      <DeactivateUser
        drawerOpen={deactivateUserDrawer}
        setDrawerOpen={setDeactivateUserDrawer}
        setPartnerRefresh={setPartnerRefresh}
        partnerRefresh={partnerRefresh}
        row={rowValue}
      />

      <DeactivatePartner
        drawerOpen={deactivatePartnerDrawer}
        setDrawerOpen={setDeactivatePartnerDrawer}
        setPartnerRefresh={setPartnerRefresh}
        partnerRefresh={partnerRefresh}
        row={rowValue}
      />

      <ActivatePartner
        drawerOpen={activatePartnerDrawer}
        setDrawerOpen={setActivatePartnerDrawer}
        setPartnerRefresh={setPartnerRefresh}
        partnerRefresh={partnerRefresh}
        row={rowValue}
      />

      <ActivateUser
        drawerOpen={activateUserDrawer}
        setDrawerOpen={setActivateUserDrawer}
        setPartnerRefresh={setPartnerRefresh}
        partnerRefresh={partnerRefresh}
        row={rowValue}
      />

      <ResendWelcomeMail
        drawerOpen={resendWelcomeMailDrawer}
        setDrawerOpen={setResendWelcomeMailDrawer}
        row={rowValue}
      />

      <PartnerViewEditUserDetails
        drawerOpen={viewPartnerEditUserDetailsDrawer}
        setDrawerOpen={setPartnerViewEditUserDetailsDrawer}
        setPartnerRefresh={setPartnerRefresh}
        partnerRefresh={partnerRefresh}
        row={rowValue}
      />

      <MakePrimaryUser
        drawerOpen={makePrimaryDrawer}
        setDrawerOpen={setMakePrimaryDrawer}
        setPartnerRefresh={setPartnerRefresh}
        partnerRefresh={partnerRefresh}
        row={rowValue}
      />

      <RemovePrimaryUser
        drawerOpen={removePrimaryDrawer}
        setDrawerOpen={setRemovePrimaryDrawer}
        setPartnerRefresh={setPartnerRefresh}
        partnerRefresh={partnerRefresh}
        row={rowValue}
      />

      <ActivatePartnerUser
        drawerOpen={activatePartnerUserDrawer}
        setDrawerOpen={setActivatePartnerUserDrawer}
        setPartnerRefresh={setPartnerRefresh}
        partnerRefresh={partnerRefresh}
        row={rowValue}
      />

      <DeactivatePartnerUser
        drawerOpen={deactivatePartnerUserDrawer}
        setDrawerOpen={setDeactivatePartnerUserDrawer}
        setPartnerRefresh={setPartnerRefresh}
        partnerRefresh={partnerRefresh}
        row={rowValue}
      />

      <ResendPartnerWelcomeMail
        drawerOpen={resendPartnerWelcomeMailDrawer}
        setDrawerOpen={setResendPartnerWelcomeMailDrawer}
        setPartnerRefresh={setPartnerRefresh}
        partnerRefresh={partnerRefresh}
        row={rowValue}
      />
    </Styles>
  );
};

const mapStateToProps = (state) => {
  return {
    state,
  };
};

export default connect(mapStateToProps)(Table);
